import React from "react";
import {BrowserRouter, Routes, Route} from "react-router-dom" ;
import About from "../Pages/About/About";
import Faq from "../Pages/Faq/Faq";
import Home from "../Pages/Home/Home";
import Meet from "../Pages/Meetthecreators/Meet";
import Roadmap from "../Pages/Roadmap/Roadmap";
import Versegame from "../Pages/Versegame/Versegame";
import Whitepaper from "../Pages/Whitepaper/Whitepaper";


const Publicroutes =()=>{
    return(
        <BrowserRouter>
        <Routes>

            <Route path="/" element={<Home />} />
            <Route path="About" element={<About />} />
            {/* <Route path="/Faq" element={<Faq />} /> */}
            <Route path="Roadmap" element={<Roadmap />} />
            <Route path="Whitepaper" element={<Whitepaper />} />
            {/* <Route path="/Meet" element={<Meet />} /> */}
            {/* <Route path="/Versegame" element={<Versegame />} /> */}
        </Routes>
        </BrowserRouter>
    )
}

export default Publicroutes